<div class="flex-control" [hidden]="!active_tab.active">
  <ng-container *ngComponentOutlet="active_tab.component;injector: custom_injector;"></ng-container>
</div>
